<script lang="ts" setup>
  import { tabItemClass, underlineBorderClass } from './TabSpacer.css';
</script>

<template>
  <div :class="tabItemClass">
    <div :class="underlineBorderClass" />
  </div>
</template>
